import React from 'react'
import SecretKey from '../components/SecretKeys/Index'

const SecretKeys = () => {
  return (
    <div className='container mx-auto'><SecretKey/></div>
  )
}

export default SecretKeys;